
  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { appointmentsModule, commonModule, dashboardModule, tasksModule } from '@/store/modules/store-accessor'

  @Component
  export default class CompleteTaskModal extends Vue {
    @Prop()
    payload!: any;

    isCompletingTask = false;

    async hideModal () {
      if(this.payload.isOrphanTask) {
        commonModule.hideSecondModal();
        commonModule.hideModal();
      } else {
        commonModule.hideModal();
      }
    }

    async mounted() {
      commonModule.initSnackbar({});
    }

    async doComplete () {
        const taskId = this.payload?.task?.id;
        if(!taskId) {
          return;
        }

        this.isCompletingTask = true;
        try {
          await tasksModule.completeTask(this.payload.task)
          await tasksModule.getTaskDetails(taskId);
          if(this.$route.name === 'Dashboard') {
             dashboardModule.getDashboardPendingTasks(dashboardModule.taskFilters);
          }
          else if(this.$route.name === 'Calendar') {
             appointmentsModule.getCalendarAppointmentsAction(appointmentsModule.filters);
          }
          this.hideModal()
        } finally {
          this.isCompletingTask = false;
        }
    }
  };
